import React from 'react'

const EmptyCart = () => {
  return (
    <>
      <div className='flex flex-col justify-center items-center text-[20px] my-[20vh] md:text-[40px]'>
        <img src={require('../../Images/cart4.png')} alt="" className='shadow-lg'/>
        <div className='my-[20px] shadow-sm'>Your cart is empty!</div>
      </div>
    </>
  )
}

export default EmptyCart
